import { store } from './store';
import { showSuccess, showError, showWarning, showInfo, Alert } from './alertSlice';

export type NotifyType = Alert['type'];

const dispatchMessage = (type: NotifyType, message: string, duration?: number) => {
  switch (type) {
    case 'success':
      return store.dispatch(showSuccess({ message, duration }));
    case 'error':
      return store.dispatch(showError({ message, duration }));
    case 'warning':
      return store.dispatch(showWarning({ message, duration }));
    case 'info':
    default:
      return store.dispatch(showInfo({ message, duration }));
  }
};

export const notifySuccess = (message: string, duration?: number) =>
  dispatchMessage('success', message, duration);

export const notifyError = (message: string, duration?: number) =>
  dispatchMessage('error', message, duration);

export const notifyWarning = (message: string, duration?: number) =>
  dispatchMessage('warning', message, duration);

export const notifyInfo = (message: string, duration?: number) =>
  dispatchMessage('info', message, duration);

export const notify = dispatchMessage;
